import {isEmpty} from 'lodash'
import {http} from '../utils/http'
import router from '../router'

export default {
  namespaced: true,
  state: {
    profile: {},
    settings: { notifications: null },
    comparisonSources: [],
    comparisonSourceLookup: {},
    comparisonSourceColumnLookup: {},
    currencyLookup: {},
    currencyColumnLookup: {},
    statementFormatLookup: {},
    statementFormatColumnLookup: {},
    statementSources: [],
    statementSourceLookup: {},
    statementSourceColumnLookup: {},
    gateways: [],
    gatewayLookup: {},
    gatewayColumnLookup: {},
    userLookup: {},
    userColumnLookup: {},
    rowTypeColumnLookup: {},
    reviewTypeColumnLookup: {},
    comparisonSourceTypeColumnLookup: {},
  },
  mutations: {
    addProfile(state, profile) {
      state.profile = profile
    },
    removeProfile(state) {
      state.profile = {}
    },
    setNotifications(state, status) {
      state.settings.notifications = status
    },
    removeSettings(state) {
      state.settings = {}
    },
    setGlobalData(state, globalData) {
      state.comparisonSources = Object.values(globalData.comparisonSources)
      state.comparisonSourceLookup = globalData.comparisonSources
      state.comparisonSourceColumnLookup = {
        dataSource: Object.values(state.comparisonSources),
        displayExpr: 'name',
        valueExpr: 'key',
      }

      state.currencyLookup = globalData.currencies
      state.currencyColumnLookup = {
        dataSource: Object.values(globalData.currencies),
        displayExpr: 'iso',
        valueExpr: 'id',
      }

      state.statementFormatLookup = globalData.statementFormats
      state.statementFormatColumnLookup = {
        dataSource: Object.values(globalData.statementFormats),
        displayExpr: 'name',
        valueExpr: 'id',
      }

      state.statementSourceLookup = globalData.statementSources
      state.statementSources = Object.values(globalData.statementSources)
      state.statementSourcesColumnLookup = {
        dataSource: state.statementSources,
        displayExpr: 'name',
        valueExpr: 'id',
      }

      state.gateways = Object.values(globalData.gateways)
      state.gatewayLookup = globalData.gateways
      state.gatewayColumnLookup = {
        dataSource: state.gateways,
        displayExpr: 'name',
        valueExpr: 'key',
      }

      state.userLookup = globalData.users
      state.userColumnLookup = {
        dataSource: Object.values(globalData.users),
        displayExpr: 'name',
        valueExpr: 'id',
      }

      state.rowTypeColumnLookup = {
        dataSource: Object.entries(globalData.rowTypes).map(([e, t]) => {
          return {
            enum: e,
            text: t,
          }
        }),
        displayExpr: 'text',
        valueExpr: 'enum',
      }

      state.reviewTypeColumnLookup = {
        dataSource: Object.entries(globalData.reviewTypes).map(([e, t]) => {
          return {
            enum: e,
            text: t,
          }
        }),
        displayExpr: 'text',
        valueExpr: 'enum',
      }

      state.comparisonSourceTypeColumnLookup = {
        dataSource: Object.entries(globalData.comparisonSourceTypes).map(
          ([e, t]) => {
            return {
              enum: e,
              text: t,
            }
          },
        ),
        displayExpr: 'text',
        valueExpr: 'enum',
      }
    },
  },
  actions: {
    async login(context, payload = { route: {} }) {
      const profile = await http.get('user/authenticated').json()

      if (isEmpty(profile)) {
        throw new Error('Empty profile received')
      }

      context.commit('addProfile', profile)
      context.commit('setNotifications', profile.role === 'L1')

      const globalData = await http
        .get('reconciliation/admin/metaData/all')
        .json()
      context.commit('setGlobalData', globalData)

      if (!isEmpty(payload.route)) {
        router.push(payload.route).catch((e) => {
          /* https://github.com/vuejs/vue-router/issues/2872 */
          console.log(e)
        })
      }
    },
    async logout({ commit }, { redirect } = { redirect: null }) {
      await http.get('user/logout')

      const payload = { name: 'login' }

      if (redirect) {
        payload.query = { redirect }
      }

      commit('removeProfile')
      commit('removeSettings')
      window.localStorage.clear()
      router.push(payload).catch((e) => {
        /* https://github.com/vuejs/vue-router/issues/2872 */
        console.log(e)
      })
    },
  },
}
